// Careers.jsx
import React, { useState } from "react";
import './Careers.css';
import { FaUser, FaEnvelope, FaBriefcase, FaFileUpload,FaFileAlt,FaPlus } from 'react-icons/fa';
import watermarkImage from "../Assets/watermark.png"; // Make sure this file exists

const Careers = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        position: "",
        resume: null,
        coverLetter: ""
    });

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const recipient = "info@vajraiot.com";
        const subject = `Job Application: ${formData.position} - ${formData.name}`;
        const body = `
            Full Name: ${formData.name}
            Email: ${formData.email}
            Position: ${formData.position}
            Cover Letter: ${formData.coverLetter || "Not provided"}
        `.trim();

        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(recipient)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.open(gmailUrl, "_blank");

        setFormData({ name: "", email: "", position: "", resume: null, coverLetter: "" });
        alert("Gmail will open in a new tab. Please attach your resume manually and click 'Send' to submit your application!");
    };

    return (
        <div className="careers-container">
            <h2>Careers at Vajra IOT Private Limited</h2>
            <p>Join our innovative team and help shape the future of IoT solutions!</p>

            <div className="application-form">
                <h3>Apply Now</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="form-group">
                            <div className="input-with-icon">
                                <FaUser className="input-icon" />
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Full Name"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-with-icon">
                                <FaEnvelope className="input-icon" />
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Email"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="input-with-icon">
                            <FaBriefcase className="input-icon" />
                            <select
                                id="position"
                                name="position"
                                value={formData.position}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="" disabled>Select Position</option>
                                <option value="Software Engineer">Software Engineer</option>
                                <option value="Firmware Engineer">Firmware Engineer</option>
                                <option value="Hardware Designer">Hardware Designer</option>
                                <option value="Hardware Testing">Hardware Testing</option>
                                <option value="ST">ST</option>
                                <option value="HR Admin">HR Admin</option>
                                <option value="Accounts">Accounts</option>
                                <option value="Salesforce">Salesforce</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                       <div className="input-with-icon">
  <div className="file-upload-icon">
    
  </div>
  <input
    type="file"
    id="resume"
    name="resume"
    accept=".pdf,.doc,.docx"
    onChange={handleInputChange}
    required
  />
</div>
                    </div>
                    <div className="form-group">
                        <textarea
                            id="coverLetter"
                            name="coverLetter"
                            value={formData.coverLetter}
                            onChange={handleInputChange}
                            placeholder="Write a brief cover letter..."
                            rows="5"
                        />
                    </div>
                    <button type="submit" className="submit-btn">Submit Application</button>
                </form>
            </div>
        </div>
    );
};

export default Careers;